(function ($) {
  'use strict';

  /**
   * Sliders
   * ---
   * Splide.js [https://splidejs.com/]
   */

  // RTL Helper
  var is_rtl = document.dir === 'rtl';
  var slider_dir = is_rtl ? 'rtl' : 'ltr';


  /**
   * Card Sliders
   * - 3 Cols
   * - Centered Slides
   */

  var slider = document.querySelectorAll( '.js-slider--auto-width' );

  if ( slider && slider.length ) {
    // slider.forEach(function ( this_slider ) {
    //   var this_slides = this_slider.querySelectorAll( '.splide__slide' );
    //   var slider_type = 'slide';
    //   var slider_arrows = false;
    //   var is_disabled = true;

    //   if ( this_slides.length >= 3 ) {
    //     slider_type = 'loop';
    //     slider_arrows = true;
    //     is_disabled = false;
    //   }

    //   new Splide( this_slider, {
    //     // Slider Config
    //     type: slider_type,
    //     arrows: slider_arrows,
    //     pagination: false,
    //     perPage: 1,
    //     focus: 'center',
    //     autoWidth: true,
    //     // Styles
    //     gap: '5.3125rem',
    //     padding: '4.375rem',
    //     direction: slider_dir,
    //     destroy: is_disabled,
    //     // Responsive Overrides
    //     breakpoints: {
    //       760: {
    //         destroy: false,
    //         type: 'loop',
    //         arrows: true,
    //         gap: '2rem',
    //       },
    //     },
    //   }).mount();
    // });

    slider.forEach(function ( this_slider ) {
      var this_slides = this_slider.querySelectorAll( '.splide__slide' );
      var slider_type = 'slide';
      var is_disabled = true;

      if ( this_slides.length >= 3 ) {
        slider_type = 'loop';
        is_disabled = false;
      }

      new Splide( this_slider, {
        // Slider Config
        type: slider_type,
        arrows: true,
        pagination: false,
        perPage: 7,
        focus: 'center',
        // Styles
        gap: '3.75rem',
        padding: '1rem',
        direction: slider_dir,
        destroy: is_disabled,
        // Responsive Overrides
        breakpoints: {
          480: {
            perPage: 2,
          },
          760: {
            perPage: 3,
            gap: '2rem',
          },
          960: {
            perPage: 5,
          },
        },
      }).mount();

    });
  }


  /**
   * Content Slider
   */

  var content_slider = document.querySelectorAll( '.js-content-slider' );

  if ( content_slider && content_slider.length ) {
    content_slider.forEach(function ( this_slider ) {
      var splide_content_slider = new Splide( this_slider, {
        type: 'slide',
        perPage: 4,
        arrows: false,
        pagination: false,
        direction: slider_dir,
        drag: false,
        // Responsive Overrides
        breakpoints: {
          480: {
            perPage: 1,
          },
          760: {
            perPage: 2,
          },
          960: {
            perPage: 3,
          }
        },
      });
      splide_content_slider.on('overflow', function ( isOverflow ) {
        splide_content_slider.options = {
          arrows: isOverflow,
        };
      });
      splide_content_slider.mount();
    });
  }


  /**
   * Quote Slider
   */

  var quote_slider = document.querySelectorAll( '.js-quote-slider' );

  if ( quote_slider && quote_slider.length ) {
    quote_slider.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        type: 'loop',
        perPage: 1,
        arrows: true,
        pagination: true,
        direction: slider_dir,
      }).mount();
    });
  }


  /**
   * Quote Slider
   */

  var image_slider = document.querySelectorAll( '.js-image-slider' );

  if ( image_slider && image_slider.length ) {
    image_slider.forEach(function ( this_slider ) {
      var this_image_slider = new Splide( this_slider, {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        rewind: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        pagination: false,
        direction: slider_dir,
      });

      // Get Toggle Controls & Labels
      var toggleButton = this_slider.querySelector( '.slider-autoplay-button' );
      var toggleButtonLabel = toggleButton.querySelector( 'span' );
      var labelPlay = toggleButton.getAttribute( 'data-label-start' );
      var labelPause = toggleButton.getAttribute( 'data-label-pause' );

      // Update toggle label on play/pause
      this_image_slider.on( 'autoplay:play', function () {
        toggleButton.setAttribute( 'aria-label', labelPause );
        toggleButton.setAttribute( 'data-is-paused', 'false' );
        toggleButtonLabel.textContent = 'Pause';
      });
      this_image_slider.on( 'autoplay:pause', function () {
        toggleButton.setAttribute( 'aria-label', labelPlay );
        toggleButton.setAttribute( 'data-is-paused', 'true' );
        toggleButtonLabel.textContent = 'Play';
      });
      this_image_slider.mount();

      // Toggle play/pause on click
      toggleButton.addEventListener( 'click', function () {
        var Autoplay = this_image_slider.Components.Autoplay;
        if ( Autoplay.isPaused() ) {
          Autoplay.play();
        } else {
          Autoplay.pause();
        }
      } );
    });
  }


  /**
   * Background Slideshow
   */

  var hero_bkg_slider = document.querySelectorAll( '.js-hero-bkg-slider' );

  if ( hero_bkg_slider && hero_bkg_slider.length ) {
    hero_bkg_slider.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        type: 'loop',
        perPage: 1,
        interval: 5000,
        arrows: false,
        pagination: false,
        drag: false,
        autoplay: true,
        direction: slider_dir,
        reducedMotion: {
          autoplay: false,
        },
      }).mount();
    });
  }

})(jQuery);
